module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/bryce-melnik-113f37a019a2e9ba4ec51c66d2100f70.jpg";